import React from 'react';
import { Box, Cluster, Stack, Text } from '@iqueue/iq-ui';

/**
 * Секция экрана по рецепту «Settings screen».
 *
 *   Stack        ритм МЕЖДУ секциями (снаружи) — красит ничего
 *     Cluster    действие секции, если оно есть
 *     Box ground ЕДИНСТВЕННЫЙ уровень, который красится; `blockRoot` даёт ему
 *                корень блока дома (радиус 20dp, инсет 4dp) — ни radius, ни
 *                padding здесь не пишем, иначе они перестанут ехать за домом
 *       List     сегментированные строки = плиты на этом ground'е
 *
 * Ни Card, ни Divider: пара «ground + сегментированный список» И ЕСТЬ группировка,
 * а разделяет секции тон и ритм, а не линия. Card пиннит свой тир и обрывает
 * цепочку углов (filled — вообще тир 4, лист: всё внутри перестаёт выводить тон).
 *
 * Видимых подписей над блоками нет — решение автора экрана: блоки различает
 * содержимое. Имя секции при этом не потеряно, оно живёт в `aria-label` списка
 * внутри: для скринридера блок остаётся названным, иначе получился бы список
 * без имени. Заголовок ВНУТРЬ блока не переносим — первой плитой он читается
 * как ещё одна строка данных, у которой почему-то нет контрола.
 *
 * `plate` — для содержимого, которое НЕ строки. У блока свой инсет 4dp, он
 * рассчитан на плиты; текст/график без плиты встаёт к стенке, тогда как строки
 * списка несут свои 16dp — по колонке секций это рваный левый край.
 */
export default function Section({ action, plate, children }) {
  return (
    <Stack gap={100}>
      {action && <Cluster justify="end">{action}</Cluster>}
      <Box surface="ground" blockRoot>
        {plate ? <Box surface="plate" padding={200}>{children}</Box> : children}
      </Box>
    </Stack>
  );
}

/**
 * Пустое состояние живёт ВНУТРИ блока: блок переживает своё содержимое, иначе
 * секция схлопывается и уносит вертикальный ритм страницы.
 * `action` — то самое средство от пустоты («создайте первого»), которое отличает
 * пустой экран от экрана, где просто нечему быть.
 */
export function Empty({ action, children }) {
  return (
    <Box padding={200}>
      <Stack gap={100} align="center">
        <Text variant="body-medium" muted>{children}</Text>
        {action}
      </Stack>
    </Box>
  );
}
